'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function IMFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-j00iags5c", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-g43w9wpho", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-ei9nkxt88" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-ei9nkxt88", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-j00iags5c)" }, /* @__PURE__ */ React.createElement("use", { fill: "#e31d1c", xlinkHref: "#mantine-ei9nkxt88" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-g43w9wpho)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M6.213 4.025c1.03 1.175 1.82 1.763 2.369 1.763.859 0 4.232-2.843 5.23-2.38.664.309 1.67 2.077 3.016 5.305l-1.316 1.65-1.7-.927-.322-3.648C11.308 6.91 9.672 7.268 8.582 6.86l-.92.773c-.59-1.169-1-1.932-1.233-2.29-.21-.321-.325-.75-.345-1.289l.06-.002a.04.04 0 01.069-.027z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M8.262 8.124l-.56.34.107-.719-.453-.509.626-.104.28-.654.28.654.626.104-.453.51.107.718zm5.113-4.694c.2 0 .363.162.363.362v1.714a.363.363 0 01-.725 0V3.792c0-.2.162-.363.362-.363z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M25.255 5.266c-1.542.25-2.459.61-2.75 1.075-.455.728.168 5.096-.753 5.696-.614.4-2.647.316-6.097-.253l-.703-1.99 1.688-.951 3.264 1.66c.205-2.445.768-4.022 1.692-4.73l-.168-1.19c1.303.12 2.169.175 2.595.167.384-.007.809.124 1.276.39l-.03.053a.04.04 0 01-.014.073z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M20.693 4.831l.009-.654.553.471.671-.114-.243.586.406.584-.702-.11-.421.476-.191-.654-.666-.29zm1.344 6.919a.373.373 0 01-.53.125l-1.501-1.002a.459.459 0 01-.175-.542.297.297 0 01.435-.149l1.631 1.012c.19.118.251.364.14.556z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M14.704 20.933c.554-1.461.702-2.435.444-2.92-.403-.758-4.497-2.402-4.556-3.5-.04-.732 1.05-2.45 3.268-5.153l2.075.386-.021 1.937-3.07 1.997c2.015 1.4 3.1 2.676 3.251 3.83l1.114.449c-.755 1.07-1.236 1.791-1.442 2.164-.186.336-.511.64-.976.91l-.03-.052a.04.04 0 01-.057-.048z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M17.362 17.199l.562.335-.685.243-.236.639-.386-.504-.709.06.446-.554-.202-.602.662.161.584-.432zm-6.784-2.475a.448.448 0 01.268-.539l1.56-.609a.508.508 0 01.616.205.348.348 0 01-.172.51l-1.782.68a.372.372 0 01-.49-.247z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        fillRule: "nonzero",
        d: "M13.663 9.765a.245.245 0 01-.149-.31c.043-.127.242-.34.366-.297l1.736.607a.24.24 0 01.16.21l.156 1.904c.01.135-.185.243-.316.254a.24.24 0 01-.257-.222l-.144-1.638z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        fillRule: "nonzero",
        d: "M16.68 8.768c.104-.083.29.013.37.119a.247.247 0 01-.041.342l-1.203 1.233c-.103.082-.337-.079-.418-.185-.08-.107-.103-.396 0-.479z"
      }
    ))))
  );
}

export { IMFlag };
//# sourceMappingURL=IM.mjs.map
